export enum PurchaseStatusEnum {
    OPEN = 'OPEN',
    INPROGRESS = 'IN PROGRESS',
    CANCELLED = 'CANCELLED',
    CLOSED = 'CLOSED'
   

  }